import { IconButton } from "@somethings-ui/web";
import { ChevronLeft, X } from "lucide-react";
import { useHubStore } from "./use-hub-store";

export const HubHeader = () => {
  const close = useHubStore((state: { close: () => void }) => state.close);
  const currentView = useHubStore((state) => state.currentView);
  const goBack = useHubStore((state) => state.goBack);

  const isNestedView = currentView !== "list";

  const handleBack = () => {
    if (isNestedView) {
      goBack();
    }
  };

  return (
    <div className="sticky top-0 flex h-[66px] w-full items-center justify-between border-b border-zinc-300 bg-white px-2">
      <div className="flex items-center gap-4">
        {isNestedView ? (
          <IconButton
            onClick={handleBack}
            variant="ghost-black"
            size="lg"
            icon={<ChevronLeft className="size-8" strokeWidth={1.5} />}
          />
        ) : null}
      </div>
      <IconButton
        onClick={close}
        variant="ghost-black"
        size="lg"
        icon={<X className="size-8" strokeWidth={1.5} />}
      />
    </div>
  );
};
